<script>
  let { label, onclick, ...rest } = $props()
</script>

<div class="flex items-center relative col-span-12 w-[102%] mx-[-1%]" {onclick} {...rest}>
  <mark class="p-2 bg-transparent ml-3 text-xs text-gray-500 z-[2]" class:cursor-pointer={onclick}>{label}</mark>
  <span class="absolute left-0 bg-gray-200/80 w-full h-px"></span>
</div>